import React from 'react';
import {default as config} from '../../config';
import Select from '../../components/form/Select.jsx';

export default class PackageSelect extends React.Component {
    getValue = () => {
        return this.select.getValue();
    }

    render () {
        let {format, onChange, value, id, includeStandard, readOnly} = this.props;
        if (format !== 'bookpack') {
            return includeStandard ? <span>Standard</span> : null;
        }
        if (readOnly) {
            let option = config.pkg_types.find(pkg => pkg.key === value);
            return option ? option.name : 'Portfolio Case';
        }
        return (<Select ref={ref=>this.select=ref} name={id} id={id} value={value} onChange={onChange}>
            {config.pkg_types.map((pkg) => {
                return <option key={`bp_pkg_${pkg.key}`} value={pkg.key}>{pkg.name}</option>;
            })}
        </Select>);
    }
}
